export const worldCupQueryKeys = {
  competition: (competitionId: string) => ['worldcup', competitionId] as const,
  matches: (competitionId: string) => ['worldcup', competitionId, 'matches'] as const,
  matchesStatic: (competitionId: string) => ['worldcup', competitionId, 'matches', 'static'] as const,
  matchesMe: (competitionId: string) => ['worldcup', competitionId, 'matches', 'me'] as const,
  standings: (competitionId: string) => ['worldcup', competitionId, 'standings'] as const,
  leaderboard: (
    competitionId: string,
    options: { limit?: number; period?: 'overall' | 'week' } = {},
  ) =>
    [
      'worldcup',
      competitionId,
      'leaderboard',
      { limit: options.limit ?? 50, period: options.period ?? 'overall' },
    ] as const,
  /** Prefix key for invalidating every leaderboard variant (all limits, all periods). */
  leaderboardAll: (competitionId: string) =>
    ['worldcup', competitionId, 'leaderboard'] as const,
  groups: (competitionId: string) => ['worldcup', competitionId, 'groups'] as const,
  group: (competitionId: string, groupId: string) =>
    ['worldcup', competitionId, 'groups', groupId] as const,
  groupLeaderboard: (
    competitionId: string,
    groupId: string,
    options: { limit?: number; period?: 'overall' | 'week' } = {},
  ) =>
    [
      'worldcup',
      competitionId,
      'groups',
      groupId,
      'leaderboard',
      { limit: options.limit ?? 100, period: options.period ?? 'overall' },
    ] as const,
  /** Infinite (paginated) squad leaderboard — distinct from the single-page key. */
  groupLeaderboardInfinite: (
    competitionId: string,
    groupId: string,
    options: { limit?: number; period?: 'overall' | 'week' } = {},
  ) =>
    [
      'worldcup',
      competitionId,
      'groups',
      groupId,
      'leaderboard',
      'infinite',
      { limit: options.limit ?? 50, period: options.period ?? 'overall' },
    ] as const,
  /** Prefix key for invalidating every group leaderboard variant (single, infinite, TV). */
  groupLeaderboardAll: (competitionId: string, groupId: string) =>
    ['worldcup', competitionId, 'groups', groupId, 'leaderboard'] as const,
  /** TV display — full paginated squad leaderboard (all pages). */
  groupLeaderboardTv: (
    competitionId: string,
    groupId: string,
    period: 'overall' | 'week' = 'overall',
  ) =>
    ['worldcup', competitionId, 'groups', groupId, 'leaderboard', 'tv', period] as const,
  memberProfile: (competitionId: string, groupId: string, memberId: string) =>
    ['worldcup', competitionId, 'groups', groupId, 'members', memberId, 'profile'] as const,
  participantProfile: (competitionId: string, memberId: string) =>
    ['worldcup', competitionId, 'participants', memberId, 'profile'] as const,
  futuresStats: (competitionId: string) =>
    ['worldcup', competitionId, 'futures-stats'] as const,
} as const;
